function initQtip() {
    if (!$.fn.qtip) return;
    $(document).find(".qtip-handle").each(function () {
            if ($(this).attr('data-hasqtip')) {
                return;
            }

            let href = $(this).attr('data-href');

            let myPosition = 'top right';

            if (isDefined($(this).data('my-position'))) {
                myPosition = $(this).data('my-position');
            }

            $(this).qtip({
                    content: {
                        text: 'Načítám...', // Loading text...
                        ajax: {
                            url: href,
                            type: 'GET',
                            success: function (data, status) {
                                this.set('content.text', data.html);
                            }
                        }
                    },
                    style: {
                        classes: 'qtip-bootstrap'
                    },
                    position: {
                        my: myPosition,  // Position my top left...
                    },
                    show: {
                        delay: 100
                    },
                    hide: {
                        fixed: true,
                        delay: 100
                    }
                }
            );
        }
    );

    $(document).find('[data-toggle="tooltip"]').each(function () {

        if ($(this).data('hasqtip') == null) {

            var title = $(this).attr("title");
            $(this).qtip({
                content: title,
                position: {
                    my: 'top center',  // Position my top left...
                    at: 'bottom center', // at the bottom right of...
                },
                style: 'qtip-bootstrap',
                show: {
                    delay: 100
                },
                html: true,
                //hide: false
                hide: {
                    fixed: true,
                    delay: 100
                }
            });

        }
    });

}

$(document).ready(function () {
    initQtip();
});

$(document).ajaxComplete(function () {
    initQtip();
});